<template>
  <a-layout-content class="content">
    <router-view  style="overflow-x: auto;"/>
  </a-layout-content>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {
    /**
    * 逻辑区
    */


    /**
    * 接口区
    */


  }
}
</script>

<style lang='scss' scoped>
  .content {
    position: absolute;
    left: 0;
    right: 0;
    top: $layout-nav-height;
    bottom: 0;
    padding: 30px;
    overflow: scroll
  }
</style>
